
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/especialidades",
      function () {
        return require("private-next-pages/especialidades/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/especialidades"])
      });
    }
  